var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inbox-item h-auto",class:{ active: _vm.active }},[_c('div',{staticClass:"inbox-item-section w-100"},[_c('router-link',{staticClass:"inbox-item-title",attrs:{"to":{
				name: 'app.schedules.show',
				params: { id: _vm.calendar.id },
			}}},[_c('div',{staticClass:"calendar-icon"},[_c('font-awesome-icon',{attrs:{"fixed-width":"","icon":['fas', 'calendar']}})],1),_vm._v(" "+_vm._s(_vm.calendar.name)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }